import { render, staticRenderFns } from "./RegisterGroup.vue?vue&type=template&id=3ce0200b&"
import script from "./RegisterGroup.vue?vue&type=script&lang=js&"
export * from "./RegisterGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports